import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AppShell from "@/components/AppShell";
import { FullPageLoader } from "@/components/Common";
import { api } from "@/lib/api";

export default function FounderStudents() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/founder/students").then(({ data }) => setData(data)).catch(() => setData({ students: [] }));
  }, []);

  if (!data) return <FullPageLoader label="Loading students…" />;

  return (
    <AppShell>
      <div className="thin-scroll mx-auto max-w-5xl px-8 py-10 ltifade" data-testid="founder-students">
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Students</h1>
        <p className="mt-1 text-slate-500">Ranked by launch readiness.</p>

        <div className="mt-6 overflow-x-auto rounded-xl border border-brand-line bg-white shadow-soft">
          <div className="min-w-[560px]">
          <div className="grid grid-cols-[1fr_1fr_100px_120px] gap-3 border-b border-brand-line bg-slate-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
            <span>Student</span><span>Current step</span><span>Readiness</span><span>Status</span>
          </div>
          {data.students.map((s) => (
            <button
              key={s.student_id}
              onClick={() => navigate(`/founder/students/${s.student_id}`)}
              data-testid={`student-row-${s.student_id}`}
              className="grid w-full grid-cols-[1fr_1fr_100px_120px] items-center gap-3 border-b border-brand-line px-4 py-3 text-left last:border-0 transition-all duration-200 hover:bg-brand-surface/40"
            >
              <div className="flex items-center gap-2.5">
                <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-brand-surface text-xs font-semibold text-brand-text">{s.initials}</span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium">{s.name}</p>
                  <p className="truncate text-xs text-slate-400">{s.business_name}</p>
                </div>
              </div>
              <span className="truncate text-sm text-slate-600">{s.focus}</span>
              <div>
                <div className="h-1.5 w-16 overflow-hidden rounded-full bg-brand-surface">
                  <div className="h-full rounded-full bg-brand" style={{ width: `${s.launch_readiness}%` }} />
                </div>
                <span className="text-xs text-slate-400">{s.launch_readiness}%</span>
              </div>
              <span>
                {s.launched ? (
                  <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-600">
                    <CheckCircle2 size={12} /> Launched
                  </span>
                ) : (
                  <span className="rounded-full bg-brand-surface px-2.5 py-0.5 text-xs font-medium text-brand-text">Building</span>
                )}
              </span>
            </button>
          ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}
